import { create } from "zustand";
import { persist } from "zustand/middleware";
import Cookies from "universal-cookie";

const initialUser = {
  isUserForceUpdateProfile: false,
  role: null,
  accessToken: null,
  refreshToken: null,
  username: null,
  id: null,
  phoneNumber: null,
  fullName: null,
  state: null,
  city: null,
  sectionType: null,
  structureType: null,
  assistance: null,
  department: null,
  organization: null,
};

export const useAppStore = create(
  persist(
    (set) => ({
      user: initialUser,
      logoutUser: () => {
        const cookies = new Cookies();
        cookies.set("accessToken", "", { path: "/" });
        set({ user: initialUser });
      },
      loginUser: (user) => {
        if (user.accessToken) {
          const cookies = new Cookies();
          cookies.set("accessToken", user.accessToken, { path: "/" });
        }
        set({ user });
      },
    }),
    { partialize: (state) => ({ user: state.user }) },
  ),
);
